import popupUtil from '@/commons/popupUtil';
import npsApi from '@/apis/integration/integrationNPSApi';

class NPSFunction {
  /**
   * Hàm show NPS
   * dqvinh 6.2.2022
   */
  checkSurvey() {
    var isCancelNPS = sessionStorage.getItem('SurveyIsCancel')
      ? Boolean(sessionStorage.getItem('SurveyIsCancel'))
      : false;
    if (isCancelNPS == false) {
      npsApi.checkSurvey().then(res => {
        sessionStorage.setItem('SurveyIsCancel', true);
        if (res.Success && res.Data) {
          popupUtil.show("NPSForm", {Data: res.Data, isAutoOn: true});
        }
      });
    }
  }

  getSurvey() {
    npsApi.getSurvey().then(res => {
      if (res.Success && res.Data) {
        popupUtil.show("NPSForm", {Data: res.Data, isAutoOn: false});
      }
    });
  }
}

export default new NPSFunction();
